import { Grid } from "@mui/material";
import { TextValidator } from "react-material-ui-form-validator";
import PropTypes from "prop-types";
import Lang from "../../Utils/lang";

const lang = Lang.getInstance();
const PERSON = {
  naturalPerson: "Persoana fizica",
  legalPerson: "Persoana juridica",
};

function PersonalInformation({ personalData, onChange, person }) {
  return (
    <>
      {person === PERSON.naturalPerson ? (
        <Grid container spacing={3}>
          <Grid item sx={12} md={6} lg={6}>
            <TextValidator
              label={lang.get("fullName")}
              type="text"
              name="fullName"
              variant="standard"
              fullWidth
              value={personalData.fullName}
              onChange={(e) => onChange(e)}
              validators={["required"]}
              errorMessages={[lang.get("textFieldRequired")]}
            />
          </Grid>
          <Grid item sx={12} md={6} lg={6}>
            <TextValidator
              label={lang.get("CNP")}
              type="text"
              name="CNP"
              variant="standard"
              fullWidth
              value={personalData.CNP}
              onChange={(e) => onChange(e)}
              validators={[
                "required",
                "matchRegexp:^[1,2,5,6,7,8].*",
                "matchRegexp:^.{13}$",
                "matchRegexp:^.{3}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])",
              ]}
              errorMessages={[
                lang.get("textFieldRequired"),
                lang.get("cnpValidation"),
                lang.get("numarCNP"),
                lang.get("ziLunaCNP"),
              ]}
            />
          </Grid>
          <Grid item sx={12} md={6} lg={6}>
            <TextValidator
              label={lang.get("phone")}
              type="text"
              name="phone"
              variant="standard"
              fullWidth
              value={personalData.phone}
              onChange={(e) => onChange(e)}
              validators={["required"]}
              errorMessages={[lang.get("textFieldRequired")]}
            />
          </Grid>
          <Grid item sx={12} md={6} lg={6}>
            <TextValidator
              label={lang.get("email")}
              type="text"
              name="email"
              variant="standard"
              fullWidth
              value={personalData.email}
              onChange={(e) => onChange(e)}
              validators={["isEmail"]}
              errorMessages={[lang.get("invalidEmail")]}
            />
          </Grid>
        </Grid>
      ) : (
        <Grid container spacing={3}>
          <Grid item sx={12} md={6} lg={6}>
            <TextValidator
              label={lang.get("legalPersonName")}
              type="text"
              name="fullName"
              variant="standard"
              fullWidth
              value={personalData.fullName}
              onChange={(e) => onChange(e)}
              validators={["required"]}
              errorMessages={[lang.get("textFieldRequired")]}
            />
          </Grid>
          <Grid item sx={12} md={6} lg={6}>
            <TextValidator
              label={lang.get("naturalPersonName")}
              type="text"
              name="legalRepresentative"
              variant="standard"
              fullWidth
              value={personalData.legalRepresentative}
              onChange={(e) => onChange(e)}
              validators={["required"]}
              errorMessages={[lang.get("textFieldRequired")]}
            />
          </Grid>
          <Grid item sx={12} md={4} lg={4}>
            <TextValidator
              label={lang.get("CIF")}
              type="text"
              name="CIF"
              variant="standard"
              fullWidth
              value={personalData.CIF}
              onChange={(e) => onChange(e)}
              validators={[
                "required",
                "matchRegexp:^([a-zA-Z]{2})?([0-9]{8}|[0-9]{7})$",
              ]}
              errorMessages={[
                lang.get("textFieldRequired"),
                lang.get("invalidCIF"),
              ]}
            />
          </Grid>
          <Grid item sx={12} md={4} lg={4}>
            <TextValidator
              label={lang.get("phone")}
              type="text"
              name="phone"
              variant="standard"
              fullWidth
              value={personalData.phone}
              onChange={(e) => onChange(e)}
              validators={["required"]}
              errorMessages={[lang.get("textFieldRequired")]}
            />
          </Grid>
          <Grid item sx={12} md={4} lg={4}>
            <TextValidator
              label={lang.get("email")}
              type="text"
              name="email"
              variant="standard"
              fullWidth
              value={personalData.email}
              onChange={(e) => onChange(e)}
              validators={["isEmail"]}
              errorMessages={[lang.get("invalidEmail")]}
            />
          </Grid>
        </Grid>
      )}
    </>
  );
}

export default PersonalInformation;

PersonalInformation.propTypes = {
  personalData: PropTypes.object,
  onChange: PropTypes.func,
  person: PropTypes.string,
};
